export const ReferLinkedInIcon: React.FC<
  React.SVGAttributes<NonNullable<unknown>>
> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37"
      height="36"
      viewBox="0 0 37 36"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.99527 0.000976562H28.7027C30.8534 0.00718913 32.9142 0.869704 34.435 2.40009C35.9558 3.93048 36.8129 6.00435 36.8191 8.16864V27.8358C36.8121 29.9996 35.9547 32.0727 34.434 33.6024C32.9133 35.1322 30.8529 35.9943 28.7027 36.0005H8.99527C6.84508 35.9943 4.78468 35.1322 3.26398 33.6024C1.74329 32.0727 0.885851 29.9996 0.878906 27.8358V8.16864C0.88508 6.00435 1.74218 3.93048 3.26295 2.40009C4.78373 0.869704 6.84458 0.00718913 8.99527 0.000976562Z"
        fill="#8065C9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2656 13.9556H19.8079V16.3102H19.8722C20.5069 15.1682 22.0512 13.9556 24.3589 13.9556C29.1527 13.9556 30.0389 16.9577 30.0389 20.8635V29.1224H25.3036V21.7818C25.3036 20.1012 25.2685 17.9379 22.8409 17.9379C20.4133 17.9379 19.998 19.7657 19.998 21.6611V29.1371H15.2656V13.9556ZM12.5777 9.35814C12.5777 9.8483 12.4333 10.3274 12.1627 10.735C11.8921 11.1425 11.5075 11.4602 11.0575 11.6478C10.6075 11.8353 10.1123 11.8844 9.63459 11.7888C9.15688 11.6932 8.71807 11.4571 8.37365 11.1105C8.02924 10.7639 7.79469 10.3224 7.69966 9.84163C7.60464 9.36089 7.65341 8.8626 7.83981 8.40975C8.0262 7.95691 8.34185 7.56986 8.74684 7.29754C9.15183 7.02523 9.62796 6.87988 10.115 6.87988C10.768 6.88066 11.3939 7.14201 11.8556 7.60661C12.3173 8.0712 12.577 8.70111 12.5777 9.35814ZM7.65819 13.9556H12.5777V29.1224H7.65819V13.9556Z"
        fill="white"
      />
    </svg>
  );
};

export default ReferLinkedInIcon;
